import React, { Component } from 'react';
import Modal from 'react-awesome-modal';
import CameraIcon from '@material-ui/icons/CameraAlt';
import BarcodeScannerComponent from "react-webcam-barcode-scanner"



var isNotFound = true;

export const Scanner=({...props})=>{
    // console.log(props)
     const [ data, setData ] = React.useState('scanning...');
    
     return (
       <>
         <BarcodeScannerComponent
           width={'300px'}
           height={'200px'}
           
           onUpdate={(err, result) => {
             if (isNotFound && result) {
               setData(result.text)
               props.setCode(result.text)
               props.closeModal()
               isNotFound = false;
               this.stopRecording()
             }
             else setData('scanning...')
           }}
         />
         <p>{data}</p>
       </>
     )
   }


export default class PopupScan extends Component {
    constructor(props) {
        super(props);
        this.state = {
            visible : false,
            code: ''
        }
    }

    openModal() {
        this.setState({
            visible : true
        });
    }

    closeModal() {
        this.setState({
            visible : false
        });
    }

    setCode=(code)=>{
        this.setState({ visible : false });
        this.setState({code : code});
        this.props && this.props.setValue(code);
    }
    
    handleOpenClick=(e)=>{
        e.preventDefault();
        this.openModal();
    }

    handleCloseClick=(e)=>{
        e.preventDefault();
        this.closeModal();
    }

    render() {
        
        return (
           
            <div>
                
                <Modal visible={this.state.visible} width="310" height="260" effect="fadeInUp"  onClickAway={() => this.closeModal()}>
                    <center>
                    <div>
                        <button style={{}}  onClick={this.handleCloseClick} 
                        style={{ 
                            backgroundColor: '#ffffff', 
                            verticallAign: 'middle',
                            float:'right', 
                            borderColor: 'white',
                            "&:hover": {backgroundColor: 'navy' },
                            zIndex: '99'
                            }}
                           >x</button>
                        { this.state.visible && <Scanner setCode={this.setCode}  closeModal={this.closeModal}/> }
                    </div>
                    </center>
                </Modal>
                <button style={{
                    backgroundColor: '#3f51b5',
                    "&:hover": {backgroundColor: 'navy'
                    },
                    textAlign: 'center', 
                    verticallAign: 'middle',
                    borderRadius: '10px',
                    color: 'white',
                    fontWeight: 'bold',
                    float: 'left',
                    width: '3em',}}  onClick={this.handleOpenClick}  > {<CameraIcon />} </button>
            </div>
        );
    }
}